import React from "react";
import { useEntity } from "apps/console/context/entity";
import { FormFieldOption } from "shared/form/fields/types";
import { ApiDivision } from "shared/types/ApiDivision";
import FormMultiSelectField from "shared/form/fields/multiSelectField";
import DynamicFieldLabel from "../DynamicFieldLabel";
import DynamicFieldConfigType from "../../types/DynamicFieldConfigType";
import { useGetDivisionsForRegistration } from "shared/dataloader";

export default function DivisionField(props: DynamicFieldConfigType) {
  const { registrationId } = useEntity();
  const { data: divisions = [] } = useGetDivisionsForRegistration({ registrationId });

  const options: Array<FormFieldOption> = React.useMemo(
    () =>
      divisions.map((o: ApiDivision) => {
        return { label: o.displayLabel, value: o.id };
      }),
    [divisions]
  );

  return (
    <FormMultiSelectField
      name={props.schemaObj.id}
      label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
      required={props.schemaObj.mandatory}
      disabled={props.schemaObj.disabled}
      options={options}
      validate={props.validationFn}
      fullWidth={props.schemaObj.fullWidthView}
      indented={props.schemaObj.indented}
    />
  );
}
